import { render } from "./designPerfume.vue?vue&type=template&id=08b91ce2&scoped=true"
import script from "./designPerfume.vue?vue&type=script&lang=js"
export * from "./designPerfume.vue?vue&type=script&lang=js"

import "./designPerfume.vue?vue&type=style&index=0&id=08b91ce2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b91ce2"]])

export default __exports__